export default "__VITE_ASSET__CiH$ry6N__"